/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Broker_Action_Will_CreateInputs */

const cs_import_broker_action_will_create = /** @type {(inputs: Import_Broker_Action_Will_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit`)
};

const en_import_broker_action_will_create = /** @type {(inputs: Import_Broker_Action_Will_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Import_Broker_Action_Will_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_broker_action_will_create = /** @type {((inputs?: Import_Broker_Action_Will_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Broker_Action_Will_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_broker_action_will_create(inputs)
	return cs_import_broker_action_will_create(inputs)
});